module.exports = __webpack_public_path__ + "img/fig2.5545bb82.png";